//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";

const jobs = [
    {
        id: 1,
        jobId: "#SK2540",
        assetTitle: "Vulnerability Scan System",
        category: "Vulnerability Scan",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "CRITICAL",
        typeBadgeColor: "success",
        postedDate: "02 December 2024",
        lastDate: "08 December 2024",
        status: "Active",
        statusBadgeColor: "success",
        description: "Perform vulnerability scans across network infrastructure, identifying potential risks and weaknesses in the system.",
    },
    {
        id: 2,
        jobId: "#SK2541",
        assetTitle: "Malware Behavior Analysis Tool",
        category: "Malware Analysis",
        location: "California",
        experience: "1-2 Years",
        position: 3,
        type: "HIGH",
        typeBadgeColor: "danger",
        postedDate: "01 December 2024",
        lastDate: "07 December 2024",
        status: "New",
        statusBadgeColor: "info",
        description: "Analyze and reverse-engineer malware samples, understanding their behavior, and providing solutions to mitigate the threat.",
    },
    {
        id: 3,
        jobId: "#SK2542",
        assetTitle: "Enterprise Threat Modeling Framework",
        category: "Threat Modeling",
        location: "Phoenix",
        experience: "-",
        position: 5,
        type: "CRITICAL",
        typeBadgeColor: "success",
        postedDate: "25 November 2024",
        lastDate: "03 December 2024",
        status: "Close",
        statusBadgeColor: "danger",
        description: "Develop and review threat models for enterprise systems, identifying potential attack vectors and suggesting mitigation strategies.",
    },
    {
        id: 4,
        jobId: "#SK2543",
        assetTitle: "Vulnerability Scan Automation Tool",
        category: "Vulnerability Scan",
        location: "California",
        experience: "0-4 Years",
        position: 8,
        type: "CRITICAL",
        typeBadgeColor: "success",
        postedDate: "28 November 2024",
        lastDate: "06 December 2024",
        status: "Active",
        statusBadgeColor: "success",
        description: "Lead the vulnerability scanning operations to assess security risks in a wide variety of systems and platforms.",
    },
    {
        id: 5,
        jobId: "#SK2544",
        assetTitle: "Advanced Malware Response System",
        category: "Malware Analysis",
        location: "Louisiana",
        experience: "5+ Years",
        position: 1,
        type: "HIGH",
        typeBadgeColor: "danger",
        postedDate: "30 November 2024",
        lastDate: "05 December 2024",
        status: "New",
        statusBadgeColor: "info",
        description: "Lead response efforts for new malware outbreaks, analyzing and developing tools to mitigate malware impact.",
    },
    {
        id: 6,
        jobId: "#SK2545",
        assetTitle: "Threat Modeling and Risk Assessment Platform",
        category: "Threat Modeling",
        location: "Oakridge Lane Richardson",
        experience: "0-2 Years",
        position: 2,
        type: "MEDIUM",
        typeBadgeColor: "info",
        postedDate: "27 November 2024",
        lastDate: "06 December 2024",
        status: "New",
        statusBadgeColor: "info",
        description: "Identify and model potential threats in systems, suggesting mitigation strategies and prioritizing threats based on impact.",
    },
    {
        id: 7,
        jobId: "#SK2546",
        assetTitle: "Vulnerability Management System",
        category: "Vulnerability Scan",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "CRITICAL",
        typeBadgeColor: "success",
        postedDate: "29 November 2024",
        lastDate: "08 December 2024",
        status: "Active",
        statusBadgeColor: "success",
        description: "Manage and oversee vulnerability assessments, ensuring that any discovered risks are addressed and mitigated promptly.",
    },
    {
        id: 8,
        jobId: "#SK2547",
        assetTitle: "Comprehensive Malware Detection System",
        category: "Malware Analysis",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "CRITICAL",
        typeBadgeColor: "success",
        postedDate: "26 November 2024",
        lastDate: "03 December 2024",
        status: "Close",
        statusBadgeColor: "danger",
        description: "Implement malware detection tools to analyze system behavior and identify malicious activity across different platforms.",
    },
    {
        id: 9,
        jobId: "#SK2548",
        assetTitle: "Targeted Threat Modeling Platform",
        category: "Threat Modeling",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "HIGH",
        typeBadgeColor: "danger",
        postedDate: "01 December 2024",
        lastDate: "08 December 2024",
        status: "New",
        statusBadgeColor: "info",
        description: "Design threat models focused on specific attack vectors, prioritizing them to enhance security posture in the organization.",
    },
    {
        id: 10,
        jobId: "#SK2549",
        assetTitle: "Enterprise Vulnerability Management Tool",
        category: "Vulnerability Scan",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "LOW",
        typeBadgeColor: "warning",
        postedDate: "29 November 2024",
        lastDate: "07 December 2024",
        status: "Active",
        statusBadgeColor: "success",
        description: "Assist in the vulnerability management process, helping to identify, assess, and report vulnerabilities in various systems.",
    }
];




const jobListCandidate = [
    {
        id: 1,
        img: avatar1,
        name: "Steven Franklin",
        designation: "UI/UX Designer",
        location: "Louisiana",
        experience: "38",
        skills: ["Bootstrap", "HTML", "CSS"],
        type: "CRITICAL",
    },
    {
        id: 2,
        img: avatar2,
        name: "Dolores Minter",
        designation: "Assistant / Shope Keeper",
        location: "Hong-Kong",
        experience: "25",
        skills: ["Shope", "Assistant"],
        type: "MEDIUM",
    },
    {
        id: 3,
        img: avatar3,
        name: "Charles Brown",
        designation: "Web Designer",
        location: "Finlande",
        experience: "24",
        skills: ["Bootstrap", "HTML", "SASS"],
        type: "HIGH",
    },
    {
        id: 4,
        img: avatar4,
        name: "Bonnie Harney",
        designation: "Web Developer",
        location: "France",
        experience: "47",
        skills: ["MYSQL", "PHP", "Laravel"],
        type: "LOW",
    },
    {
        id: 5,
        img: avatar5,
        name: "Stephen Hadley",
        designation: "Graphic Designer",
        location: "Danemark",
        experience: "83",
        skills: ["Figma", "Adobe XD", "Sketch"],
        type: "LOW",
    },
    {
        id: 6,
        img: avatar6,
        name: "Henry Wells",
        designation: "Executive, HR Operations",
        location: "Danemark",
        experience: "65",
        skills: ["HR", "Executive", "Professional"],
        type: "LOW",
    },
    {
        id: 7,
        img: avatar7,
        name: "Adam Miller",
        designation: "Education Training",
        location: "Colombie",
        experience: "38",
        skills: ["Teaching", "React", "Training"],
        type: "CRITICAL",
    },
    {
        id: 8,
        img: avatar8,
        name: "Keith Gonzales",
        designation: "Product Manager",
        location: "Brazil",
        experience: "50",
        skills: ["Manager", "Business", "Product"],
        type: "MEDIUM",
    },
];

const jobApply = [
    {
        id: 10,
        no: 10,
        jobTitle: "Magento Developer",
        companyName: "Web Technology pvt.Ltd",
        type: "LOW",
        applyDate: "02 June 2021",
        status: "Active",
    },
    {
        id: 9,
        no: 9,
        jobTitle: "Magento Developer",
        companyName: "Adobe Agency",
        type: "MEDIUM",
        applyDate: "02 June 2021",
        status: "New",
    },
    {
        id: 8,
        no: 8,
        jobTitle: "Magento Developer",
        companyName: "Web Technology pvt.Ltd",
        type: "CRITICAL",
        applyDate: "02 June 2021",
        status: "Close",
    },
    {
        id: 7,
        no: 7,
        jobTitle: "Magento Developer",
        companyName: "Web Technology pvt.Ltd",
        type: "HIGH",
        applyDate: "25 June 2021",
        status: "Active",
    },
    {
        id: 6,
        no: 6,
        jobTitle: "Magento Developer",
        companyName: "Themesbrand",
        type: "MEDIUM",
        applyDate: "25 June 2021",
        status: "Close",
    },
    {
        id: 5,
        no: 5,
        jobTitle: "Product Sales Specialist",
        companyName: "New Technology pvt.Ltd",
        type: "HIGH",
        applyDate: "25 June 2021",
        status: "New",
    },
    {
        id: 4,
        no: 4,
        jobTitle: "HTML Developer",
        companyName: "Skote Technology pvt.Ltd",
        type: "CRITICAL",
        applyDate: "02 June 2021",
        status: "Active",
    },
    {
        id: 3,
        no: 3,
        jobTitle: "Magento Developer",
        companyName: "Web Technology pvt.Ltd",
        type: "CRITICAL",
        applyDate: "02 June 2021",
        status: "Close",
    },
    {
        id: 2,
        no: 2,
        jobTitle: "Apple School & College",
        companyName: "Themesbrand",
        type: "HIGH",
        applyDate: "15 June 2021",
        status: "New",
    },
    {
        id: 1,
        no: 1,
        jobTitle: "Magento Developer",
        companyName: "Creative Agency",
        type: "CRITICAL",
        applyDate: "02 June 2021",
        status: "Active",
    },
];

const chartsData = [
    {
        id: 1,
        title: "Vulnerabilities",
        price: "14",
        perstangeValue: "18.89",
        badgeColor: "success",
        seriesData: [{
            name: "Vulnerabilities",
            data: [36, 21, 65, 22, 35, 50, 87, 98],
        }],
        color: '["--bs-success", "--bs-transparent"]'
    },
    {
        id: 2,
        title: "Patches",
        price: "7",
        perstangeValue: "24.07",
        badgeColor: "success",
        seriesData: [{
            name: "Patches",
            data: [36, 48, 10, 74, 35, 50, 70, 73],
        }],
        color: '["--bs-success", "--bs-transparent"]'
    },
    {
        id: 3,
        title: "Resolutions",
        price: "10",
        perstangeValue: " 8.41",
        badgeColor: "success",
        seriesData: [{
            name: "Resolutions",
            data: [60, 14, 5, 60, 30, 43, 65, 84],
        }],
        color: '["--bs-danger", "--bs-transparent"]'
    },
    {
        id: 4,
        title: "Risk Score",
        price: "B",
        perstangeValue: " 20.63",
        badgeColor: "danger",
        istrendingArrow: true,
        seriesData: [{
            name: "Risk Score",
            data: [32, 22, 7, 55, 20, 45, 36, 20],
        }],
        color: '["--bs-success", "--bs-transparent"]'
    },
];
export { jobs, jobListCandidate, jobApply, chartsData };